import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { PetrusError, config, StorageDrivers } from "../config";
import { configure as oAuth } from "../modules/oAuth";
import { configure as authSession } from "../modules/auth-session";
import { configure as tokens, tokensPersistenceInitialState, tokensPersistence as TokensPersistence } from "../modules/tokens";
import createRootReducer from "../services/reducers";
import rootSaga from "../services/sagas";
config.initialized = false;
export default function configure(customConfig = {}) {
  if (config.initialized) {
    throw new PetrusError(`'configure' method can be called only once.`);
  } // get default  tokens persistence from tokens reducer initial state


  const initialState = tokens.initialState(customConfig.initialState);
  const tokensPersistence = initialState.tokensPersistence || tokensPersistenceInitialState;
  const oAuthConfig = oAuth(customConfig.oAuth);
  Object.assign(config, {
    initialized: true,
    logger: customConfig.logger || console,
    reducerKey: customConfig.reducerKey || 'auth',
    oAuth: oAuthConfig,
    tokens: tokens.options(customConfig.tokens),
    remoteHandlers: _objectSpread(_objectSpread({}, authSession.handlers(customConfig.handlers, {
      oAuthEnabled: oAuthConfig.enabled,
      tokensPersistence
    })), tokens.handlers(customConfig.handlers)),
    mapStorageDriverToTokensPersistence: _objectSpread({
      [TokensPersistence.SESSION]: StorageDrivers.sessionStorage,
      [TokensPersistence.LOCAL]: StorageDrivers.indexedDB,
      [TokensPersistence.NONE]: StorageDrivers.reset
    }, customConfig.mapStorageDriverToTokensPersistence)
  });
  Object.freeze(config);
  return {
    reducer: createRootReducer(initialState),
    saga: rootSaga
  };
}